export function getProductRedirectErrorMessage(error: any) {
  const status = Number(
    error?.response?.status ??
      error?.response?.data?.statusCode ??
      error?.response?.data?.code
  )
  const rawMessage = error?.response?.data?.message
  const apiMessage = Array.isArray(rawMessage)
    ? rawMessage.find((message) => typeof message === 'string')
    : rawMessage

  if (status !== 401 && status !== 404) return null

  if (typeof apiMessage === 'string' && apiMessage.trim()) {
    return apiMessage
  }

  return status === 401 ? 'Unauthorized' : 'Product not found'
}
